const inMemoryStorage = () => {
    let storage = {};
    const read = async (key) => storage[key] || null;
    const list = async () => Object.values(storage);
    const write = async (key, value) => {
        storage[key] = value;
    };
    const remove = async (key) => {
        delete storage[key];
    };
    const clear = async () => {
        storage = {};
    };
    return { read, list, write, remove, clear };
};
export { inMemoryStorage };
